<template>
	<div id="transitCalculator">
		<b-card title="Transit Calculator" bg-variant="dark" text-variant="white">
			<b-form @submit="calculateTransitTime">
			<label class="mr-sm-2" for="ra_id"> RA (Degrees)</label>
			<b-input
				id="ra_id"
				class="mb-2 mr-sm-2 mb-sm-0"
				placeholder="0.0"
				v-model="ra"
				:state="validateRA"
			></b-input>
			<b-form-invalid-feedback :state="validateRA">
				RA must be between 0 and 360.
			</b-form-invalid-feedback>
			<label class="mr-sm-2" for="dec_id"> Dec (Degrees)</label>
			<b-input
				id="dec_id"
				class="mb-2 mr-sm-2 mb-sm-0"
				placeholder="0.0"
				v-model="dec"
				:state="validateDec"
			></b-input>
			<b-form-invalid-feedback :state="validateDec">
				Dec must be between -180 and 180.
			</b-form-invalid-feedback>
			<label class="mr-sm-2" for="date_id"> Date('YYYY-MM-DD')</label>
			<b-input
				id="date_id"
				class="mb-2 mr-sm-2 mb-sm-0"
				placeholder="2020-12-25"
				v-model="date"
				type="date"
				:state="validateDate"
			></b-input>
			<b-form-invalid-feedback :state="validateDate">
				Invalid Date: Must be YYYY-MM-DD eg. 2020-12-25
			</b-form-invalid-feedback>
			<b-button type="submit" variant="primary">Submit</b-button>
			</b-form>
			<div v-if="ra!== null && dec !== null && validateDate">
				<h4>RA: {{ra}}, Dec: {{dec}}, Date: {{date}}</h4>
				<div style="color: orange">
					<table style="text-align: center; border: 1px solid cyan; width: 100%">
						<thead>
							<th>
								Transit
							</th>
							<th>
								Peak Transit time
							</th>
							<th>
								ApproximateTransit Duration
							</th>
						</thead>
						<tr>
							<td>
								Upper
							</td>
							<td>
								{{upperTransit[0]}}
							</td>
							<td>
								{{upperTransit[1]}}
							</td>
						</tr>
						<tr v-if="lowerTransit[1] !== 0">
							<td>
								Lower
							</td>
							<td>
								{{lowerTransit[0]}}
							</td>
							<td>
								{{lowerTransit[1]}}
							</td>
						</tr>
					</table>
				</div>
			</div>
		</b-card>
	</div>
</template>

<script>

export default {
	name: 'transitCalculator',
	data () {
		return {
			peakTransitTime: '',
			upperTransit: {},
			lowerTransit: {},
			ra: null,
			dec: null,
			date: null
		}
	},
	methods: {
		calculateTransitTime (evt) {
			evt.preventDefault()
			var url = 'https://catalog.chime-frb.ca/calculate-transit'
			const payload = {'ra': parseFloat(this.ra), 'dec': parseFloat(this.dec), 'date': this.date}
			console.log(payload)
			this.$http.post(url, payload)
				.then(response => {
				if (response.body) {
					this.peakTransitTime = response.body.peak_transit_time
					this.upperTransit = response.body.upper_transit
					this.lowerTransit = response.body.lower_transit
				}
			})
		},
	},
	computed: { 
		validateRA () {
			return this.ra !== null && this.ra >=0 && this.ra <= 360
		},
		validateDec () {
			return this.dec !== null && this.dec >=-180 && this.dec <= 180
		},
		validateDate () {
			console.log(Date.parse(this.date))
			return this.date !== null && Date.parse(this.date) >= 0 && this.date.includes('-') && this.date.length === 10
		}
	}
}
</script>
